import { SubHeading } from "../../components";
import { images } from "../../constants";
import "./Chef.css";

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="Kockens ord" />
      <h1 className="headtext__cormorant">Vad vi tror på</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="" />
          <p className=" p__opensans">
            kärleken till matlagning är nyckeln till att skapa minnesvärda
            smakupplevelser som förenar människor runt matbordet.
          </p>
        </div>
        <p className=" p__opensans">
          Smaker dansar i harmoni, förenar själar vid matbordet. Konsten att
          älska maten är kockens ständiga mål.
        </p>
      </div>

      <div className="app__chef-sign">
        <p>Kevin Luo</p>
        <p className="p__opensans">Kock & Grundare</p>
        <img src={images.sign} alt="" />
      </div>
    </div>
  </div>
);

export default Chef;
